// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/users.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/users'

import { Icon, type IconComponentProps } from '../icon'

export const UsersIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
